import Enum from './Enum.js';

export default class AllowanceStatus extends Enum {
  static ACTIVE = new AllowanceStatus('ACTIVE', '有効');
  static INACTIVE = new AllowanceStatus('INACTIVE', '無効');
}
